import { Component, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { lastValueFrom } from 'rxjs';
import {
  BfluenceIntegrityControllerService,
  DeadlockedBenefit
} from 'src/app/admin-api';
import { TableColumn, TableComponent } from 'src/app/components/table';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-deadlocked-benefit',
  templateUrl: './deadlocked-benefit.component.html',
  styleUrl: './deadlocked-benefit.component.scss',
  providers: [ConfirmationService, MessageService]
})
export class DeadlockedBenefitComponent {
  @ViewChild(TableComponent) table: TableComponent;

  columns: Array<TableColumn> = [
    new TableColumn('', '', false, 'checkbox'),
    new TableColumn(
      'PersonId',
      'personId',
      true,
      'number',
      '/users/person/',
      'personId'
    ),
    new TableColumn(
      'SubscriberId',
      'subscriberId',
      true,
      'number',
      '/users/subscribers/',
      'subscriberId'
    ),
    new TableColumn('PaymentId', 'creditCardPaymentId', true, 'number'),
    new TableColumn('CardId', 'creditCardId', true, 'number'),
    new TableColumn('DateAuthorized', 'dateAuthorized', true, 'date'),
    new TableColumn('SubscriptionTypeId', 'subscriptionTypeId', true, 'number'),
    new TableColumn('CouponName', 'couponName', true, 'text')
  ];

  constructor(
    public bfluenceIntegrityService: BfluenceIntegrityControllerService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) {}

  markAsResolved(elements: Array<DeadlockedBenefit>): void {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      rejectButtonStyleClass: 'p-button-danger',
      message: 'Deseja ajustar este(s) benefício(s)?',
      header: 'Ajustar Benefícios',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await lastValueFrom(
            this.bfluenceIntegrityService.fixDeadlockedBenefits(elements)
          );
          await this.table.refresh(true);
          this.messageService.add({
            summary: 'Sucesso',
            detail: elements.length + ' marcado(s) como resolvido(s)',
            severity: 'success'
          });
          LoaderService.showLoader(false);
        } catch (error) {
          LoaderService.showLoader(false);
          AppDialogService.showErrorDialog(error);
        }
      }
    });
  }
}
